import { render, staticRenderFns } from "./UpdateOrderStatus.vue?vue&type=template&id=0378b82b&scoped=true&"
import script from "./UpdateOrderStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrderStatus.vue?vue&type=style&index=0&id=0378b82b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0378b82b",
  null
  
)

export default component.exports